import { useDispatch, useSelector } from 'react-redux';
import { getUser } from 'api/auth';
import { updateUserLastLogin } from 'api/users';
import { getTokenExpirationDate, getIdToken } from 'utils/okta';
import { dateDifferenceInHours } from 'utils/date';
import actions from 'store/actions';
import some from 'lodash/some';
import okta from 'constants/okta';

export function useUserFetching() {
    const hasIdToken = Boolean(getIdToken());
    const dispatch = useDispatch();
    const currentUser = useSelector((state) => state.user);

    const fetchUser = async () => {
        if (!hasIdToken || !currentUser || some(currentUser)) return;

        let user = await getUser();

        const lastLoginDate = new Date(user.lastLogin);
        const tokenDate = new Date(getTokenExpirationDate());

        if (tokenDate &&
            lastLoginDate &&
            dateDifferenceInHours(tokenDate, lastLoginDate) > okta.tokenExpirationTimeHrs) {
            user = await updateUserLastLogin(user);
        }

        dispatch(actions.user.setUser(user));
    };

    return [!currentUser, { fetchUser }];
}